/**
 * Measured geometry of the official Form W-7 (Rev. August 2019), extracted
 * from the PDF's vector content stream. Units are PDF points, y from the top.
 *
 * GENERATED — do not hand-edit. Re-derive from fw7.pdf if the form revision
 * changes. The replica renders these directly, so its rules are the official's
 * rules rather than an approximation of them.
 */

/**
 * Horizontal rules: [y, x0, x1] or [y, x0, x1, 1] where a trailing 1 marks a
 * DOTTED rule. Six of the write-in rules on the official are dotted rather
 * than solid — a 3pt period at ~67% duty, i.e. a 2pt dash over a 1pt gap,
 * measured off the form at 288dpi. Everything else is a solid hairline.
 */
export const H_RULES: readonly (readonly number[])[] = [
  [84.0, 35.8, 122.9],
  [84.0, 122.2, 489.9],
  [84.0, 489.1, 576.2],
  [84.5, 439.2, 576.0],
  [119.3, 439.2, 576.0],
  [120.0, 35.8, 439.4],
  [192.0, 476.9, 576.2, 1],
  [216.0, 523.0, 576.2, 1],
  [228.0, 222.9, 576.2, 1],
  [264.0, 158.2, 576.2, 1],
  [276.0, 35.8, 108.2],
  [276.0, 107.8, 273.9],
  [276.0, 273.4, 410.7],
  [276.0, 410.1, 576.2],
  [300.0, 107.8, 273.9],
  [300.0, 273.4, 410.7],
  [300.0, 410.1, 576.2],
  [324.0, 35.8, 108.2],
  [324.0, 107.8, 273.9],
  [324.0, 273.4, 410.7],
  [324.0, 410.1, 576.2],
  [348.0, 107.8, 576.2],
  [372.0, 35.8, 108.2],
  [372.0, 107.8, 576.2],
  [396.0, 107.8, 576.2],
  [420.0, 35.8, 108.2],
  [420.0, 107.8, 576.2],
  [444.0, 35.8, 108.2],
  [444.0, 107.8, 230.7],
  [444.0, 230.2, 338.6],
  [444.0, 338.1, 475.4],
  [444.0, 474.9, 489.8],
  [444.0, 489.4, 576.2],
  [468.0, 107.8, 230.7],
  [468.0, 230.2, 367.5],
  [468.0, 366.9, 576.2],
  [492.0, 273.4, 381.9, 1],
  [516.0, 107.8, 576.2],
  [552.0, 108.0, 576.0],
  [576.0, 251.8, 345.9],
  [576.0, 352.6, 439.5],
  [576.0, 446.1, 576.2],
  [588.0, 108.0, 576.0],
  [600.0, 339.8, 576.2, 1],
  [612.0, 35.8, 108.2],
  [612.0, 107.8, 576.2],
  [672.0, 129.3, 338.6],
  [672.0, 338.1, 417.8],
  [672.0, 417.4, 432.2],
  [672.0, 431.8, 475.4],
  [672.0, 474.9, 576.2],
  [696.0, 35.8, 108.2],
  [696.0, 107.8, 129.8],
  [696.0, 129.3, 338.6],
  [696.0, 338.1, 417.8],
  [696.0, 417.4, 432.2],
  [696.0, 431.8, 576.2],
  [708.0, 431.8, 576.2],
  [720.0, 107.8, 129.8],
  [720.0, 129.3, 295.4],
  [720.0, 294.9, 403.4],
  [720.0, 402.9, 489.9],
  [720.0, 489.4, 576.2],
  [732.0, 402.9, 489.9],
  [732.0, 489.4, 576.2],
  [744.0, 35.8, 281.1],
  [744.0, 280.6, 489.9],
  [744.0, 489.4, 576.2],
];

/** Vertical rules: [x, yTop, yBottom] */
export const V_RULES: readonly (readonly number[])[] = [
  [108.0, 275.8, 300.3],
  [108.0, 299.7, 324.2],
  [108.0, 323.7, 372.2],
  [108.0, 371.7, 420.2],
  [108.0, 419.8, 444.3],
  [108.0, 443.7, 612.2],
  [108.0, 611.8, 660.2],
  [108.0, 647.8, 696.2],
  [108.0, 695.7, 744.2],
  [122.4, 35.8, 56.3],
  [122.4, 55.8, 66.3],
  [122.4, 65.7, 84.5],
  [230.4, 419.8, 444.3],
  [230.4, 443.7, 468.2],
  [273.6, 275.8, 300.3],
  [273.6, 299.7, 324.2],
  [295.2, 719.8, 744.3],
  [338.4, 419.8, 444.3],
  [338.4, 659.7, 672.2],
  [338.4, 671.8, 696.3],
  [338.4, 695.7, 708.2],
  [338.4, 707.8, 720.2],
  [367.2, 443.7, 468.2],
  [403.2, 719.8, 732.2],
  [403.2, 731.7, 744.2],
  [410.4, 275.8, 300.3],
  [410.4, 299.7, 324.2],
  [432.0, 659.7, 672.2],
  [432.0, 695.7, 708.2],
  [432.0, 707.8, 720.2],
  [439.2, 84.5, 119.3],
  [475.2, 419.8, 444.3],
  [489.6, 35.8, 84.5],
  [489.6, 719.8, 732.2],
  [576.0, 84.5, 119.3],
];

/** Every checkbox on the form is 8 x 8pt. Positions are [x, y] of the corner. */
export const CHECKBOX_PT = 8;
export const CHECKBOXES: readonly (readonly number[])[] = [
  [52.4, 146.0],
  [52.4, 158.0],
  [52.4, 170.0],
  [52.4, 182.0],
  [52.4, 206.0],
  [52.4, 230.0],
  [52.4, 242.0],
  [52.4, 254.0],
  [129.6, 529.8],
  [129.6, 541.5],
  [131.6, 482.0],
  [239.6, 482.0],
  [333.2, 470.0],
  [398.0, 470.0],
  [434.0, 674.0],
  [434.0, 686.0],
  [453.6, 97.3],
  [453.6, 107.7],
  [477.2, 674.0],
  [491.6, 422.0],
  [491.6, 433.5],
];
